import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe(
  import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY as string,
);

export function StripeWrapper({ children }: { children: React.ReactNode }) {
  return (
    <Elements
      stripe={stripePromise}
      options={{
        appearance: {
          variables: {
            colorPrimary: "white",
          },
        },
      }}
    >
      {children}
    </Elements>
  );
}
